import I18n from 'I18n';
import { useEffect, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { FloatingAlertList, FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Select } from 'foundations-components/transitional/components/Select';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
//@ts-expect-error upstream is not TS
import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap';
import { RequestAccessModalWrapper } from '../../RequestAccessModalWrapper';
import { UIAUMetrics } from '../../_core/utils/metricUtils';
import { trackClickedRequestSeatButton, trackViewedRequestSeatButton } from './request-seat-trackers';
import { requestSeatUpgrade } from './requestSeatApi';
import { useRequestSeatModalData } from './useRequestSeatModalData';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const UIRequestSeatButton = props => {
  const {
    level,
    showSeatSelector,
    upgradeData,
    usageLimitBannerData
  } = props;
  const correctedApiName = upgradeData.apiName || UpgradeProductToApiNameMap[upgradeData.upgradeProduct];
  const [localAlertStore] = useState(() => {
    return FloatingAlertStore.newFloatingAlertStore();
  });
  const requestSeatModalData = useRequestSeatModalData();
  const [requestReason, setRequestReason] = useState();
  const [selectedSeatType, setSelectedSeatType] = useState(correctedApiName ? null : requestSeatModalData.defaultSeat);
  const metricTrackingDetails = {
    // cast as a string because apiName will always be available for seated products
    // and metric js will throw an error
    apiName: upgradeData.apiName,
    isEmbeddedInBanner: usageLimitBannerData ? 'true' : 'false'
  };
  const handleClickRequestSeat = () => {
    UIAUMetrics.counter('request-seat-click', metricTrackingDetails).increment();
    trackClickedRequestSeatButton({
      upgradeData,
      level,
      usageLimitBannerData
    });
  };
  useEffect(() => {
    trackViewedRequestSeatButton({
      upgradeData,
      level,
      usageLimitBannerData
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FloatingAlertList, {
      alertStore: localAlertStore
    }), /*#__PURE__*/_jsx(RequestAccessModalWrapper, {
      buttonUse: props.use || 'primary',
      buttonSize: props.size,
      buttonBlock: props.block,
      floatingAlertStore: localAlertStore,
      requestAccessPromise: () => {
        const requestSeatPromise = requestSeatUpgrade({
          apiName: correctedApiName,
          requestReason,
          requestedSeatType: selectedSeatType
        });
        requestSeatPromise.then(__response => {
          UIAUMetrics.counter('request-seat-success', metricTrackingDetails).increment();
        }).catch(error => {
          UIAUMetrics.counter('request-seat-failure', Object.assign({}, metricTrackingDetails, {
            message: error.message
          })).increment();
        });
        return requestSeatPromise;
      },
      usageTrackingProperties: {
        apiName: correctedApiName,
        apiNames: [correctedApiName],
        modalType: 'requestSeatUpgrade',
        screen: upgradeData.screen,
        source: upgradeData.source || '',
        upgradeProduct: upgradeData.upgradeProduct,
        upgradeProducts: [upgradeData.upgradeProduct],
        app: upgradeData.app,
        uniqueId: upgradeData.uniqueId,
        upgradeSource: upgradeData.upgradeSource || ''
      },
      modalWidth: 480,
      onClickOpenModal: handleClickRequestSeat,
      OpenModalButtonLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.requestSeatButton"
      }),
      ModalBody: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          marginBlockEnd: "400",
          children: [/*#__PURE__*/_jsx(Illustration, {
            name: "lock",
            height: 60,
            marginBlockEnd: "400"
          }), /*#__PURE__*/_jsx(Text, {
            typography: "heading-50",
            marginBlockEnd: "0",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "upgrades.requestSeatModal.body.title"
            })
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.requestSeatModal.body.subtitle"
          })]
        }), showSeatSelector || !correctedApiName && requestSeatModalData.availableSeatOptions.length > 0 ? /*#__PURE__*/_jsx(FormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.requestSeatModal.seatInputSelect.title"
          }),
          children: /*#__PURE__*/_jsx(Select, {
            marginBlockEnd: "400",
            "data-test-id": `admin-only-modal-requestSeatUpgrade-new-seat-selector`,
            onChange: event => {
              setSelectedSeatType(event.target.value);
            },
            options: requestSeatModalData.availableSeatOptions,
            defaultValue: requestSeatModalData.defaultSeat
          })
        }) : null, /*#__PURE__*/_jsx(FormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.requestSeatModal.reasonInput.header"
          }),
          children: /*#__PURE__*/_jsx(TextArea, {
            value: requestReason,
            onChange: event => {
              setRequestReason(event.target.value);
            },
            placeholder: I18n.text('upgrades.requestSeatModal.reasonInput.placeholder')
          })
        })]
      }),
      ModalTitle: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `upgrades.requestSeatModal.title`
      }),
      SubmitRequestButtonLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `upgrades.adminModal.requestSeatUpgrade.button`
      })
    })]
  });
};
export default UIRequestSeatButton;